import type { ComplianceOverviewCounts } from '@chukua/common';
import { OVERVIEW_BUCKETS } from '@chukua/common';
import { OVERVIEW_BUCKET_LABELS } from '../policies/overview-bucket-labels';

interface ComplianceOverviewCountTilesProps {
  counts: ComplianceOverviewCounts;
}

/** The count tile the future dashboard will also read (gitaumoses4/chukua#18) — this page's own summary row above the list. */
export function ComplianceOverviewCountTiles({ counts }: ComplianceOverviewCountTilesProps) {
  return (
    <div className="mb-6 grid grid-cols-2 gap-3 sm:grid-cols-4">
      {OVERVIEW_BUCKETS.map((bucket) => (
        <div key={bucket} className="rounded-lg border border-line bg-surface px-4 py-3">
          <p className="text-2xl font-semibold text-fg">{counts[bucket]}</p>
          <p className="text-sm text-muted">{OVERVIEW_BUCKET_LABELS[bucket].label}</p>
        </div>
      ))}
    </div>
  );
}
